export const ROUTES = {
  HOME: "/",
};

export const DOWNLOAD_FILE_TYPES = {
  NEW_TAB: "NEW_TAB",
  DOWNLOAD: "DOWNLOAD",
  CURRENT_TAB: "CURRENT_TAB",
};
